import React, { useState } from 'react';
import { ReactComponent as StoreIcon } from '../../assets/icn_store.svg';
import { ReactComponent as HomeIcon } from '../../assets/icn_home.svg';
import './LocationServices.css';
import { useBooking } from '../../context/contexts';
import { icn_close } from '../../imports';

const LocationServices = () => {
  const { location, selectLocation } = useBooking();
  const [showAtHomeNotice, setShowAtHomeNotice] = useState(true);

  const handleSelect = (type) => {
    selectLocation(type);
    if (type !== 'atHome') setShowAtHomeNotice(true); // reset notice if switching back
  };

  return (
    <div className="location-services-container">
      {location === 'atHome' && showAtHomeNotice && (
        <div className="at-home-notification">
          <span className="notification-text">
            Additional $50 for home service apply
          </span>
          <button className="notification-close" onClick={() => setShowAtHomeNotice(false)} aria-label="Close notification">
            <img src={icn_close} alt="Close" width={18} height={18} />
          </button>
        </div>
      )}
      <div className="location-services-title">Choose where we'll detail your car</div>
      <div className="location-options">
        <button
          className={`location-option ${location === 'inStore' ? 'selected' : ''}`}
          onClick={() => handleSelect('inStore')}
        >
          <StoreIcon className="location-icon" />
          <span>In Store</span>
          <span className="radio-indicator">{location === 'inStore' ? <span className="dot" /> : null}</span>
        </button>
        <button
          className={`location-option ${location === 'atHome' ? 'selected' : ''}`}
          onClick={() => handleSelect('atHome')}
        >
          <HomeIcon className="location-icon" />
          <span>At Home</span>
          <span className="radio-indicator">{location === 'atHome' ? <span className="dot" /> : null}</span>
        </button>
      </div>
    </div>
  );
};

export default LocationServices;
